<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toastMessage, dialog, answerDialog } from "@/utils/feedback.js";
const route = useRoute(),
  router = useRouter();
const tabs = [
  { path: "/pages/tabs/home", text: "首页", icon: "home" },
  { path: "/pages/tabs/order", text: "订单", icon: "order" },
  { path: "/pages/tabs/mine", text: "我的", icon: "mine" },
];
const showTabs = computed(
  () =>
    tabs.some((tab) => tab.path === route.path) ||
    route.path === "/pages/mine/publish",
);
</script>
<template>
  <RouterView :key="route.fullPath" />
  <nav v-if="showTabs" class="h5-tabbar" aria-label="主导航">
    <button
      v-for="tab in tabs"
      :key="tab.path"
      :class="{
        active:
          route.path === tab.path ||
          (route.path === '/pages/mine/publish' && tab.icon === 'mine'),
      }"
      @click="router.push(tab.path)"
    >
      <svg class="tab-icon" viewBox="0 0 48 48" aria-hidden="true">
        <template v-if="tab.icon === 'home'">
          <path d="M8 23.5 24 10l16 13.5v17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z" />
          <path d="M18 42V28h12v14" />
        </template>
        <template v-else-if="tab.icon === 'order'">
          <path d="M15 10h18a4 4 0 0 1 4 4v28H11V14a4 4 0 0 1 4-4z" />
          <path d="M19 10a5 5 0 0 1 10 0M18 23h12M18 31h12" />
        </template>
        <template v-else>
          <path
            d="M24 25a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 42c2.4-8 7-12 13-12s10.6 4 13 12z"
          />
        </template></svg
      ><small>{{ tab.text }}</small>
    </button>
  </nav>
  <div v-if="toastMessage" class="uni-toast" role="status">
    {{ toastMessage }}
  </div>
  <div
    v-if="dialog"
    class="feedback-mask"
    role="presentation"
    @keydown.esc="answerDialog(false)"
  >
    <section
      class="feedback-dialog"
      role="dialog"
      aria-modal="true"
      :aria-label="dialog.title"
    >
      <h3>{{ dialog.title }}</h3>
      <p>{{ dialog.content }}</p>
      <div class="feedback-actions">
        <button @click="answerDialog(true)">{{ dialog.confirmText }}</button
        ><button
          v-if="dialog.showCancel !== false"
          @click="answerDialog(false)"
        >
          {{ dialog.cancelText }}
        </button>
      </div>
    </section>
  </div>
</template>
<style>
.feedback-mask {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: #0007;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.feedback-dialog {
  width: 100%;
  max-width: 320px;
  background: white;
  color: #111;
  border-radius: 10px;
  text-align: center;
  overflow: hidden;
}
.feedback-dialog h3 {
  padding: 24px 18px 8px;
  margin: 0;
  font-size: 18px;
}
.feedback-dialog p {
  padding: 0 22px 24px;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.5;
}
.feedback-actions {
  display: flex;
  border-top: 1px solid #eee;
}
.feedback-actions button {
  flex: 1;
  height: 50px;
  border: 0;
  border-radius: 0;
  background: white;
  color: #111;
  margin: 0;
}
.feedback-actions button + button {
  border-left: 1px solid #eee;
  color: #666;
}
button:disabled {
  opacity: 0.55;
  cursor: wait;
}
</style>
